import { useTranslation } from "react-i18next";
import styles from "./States.module.css";

/**
 * The shared "no data" state — an honest, explicit "there is nothing here", never a fabricated
 * zero or a blank screen. Used directly by the phase 4 "My consumption" placeholder, and intended
 * for every later screen's genuinely-empty case.
 *
 * @param props.title - Overrides the default heading.
 * @param props.description - Overrides the default explanatory text.
 * @param props.children - Optional content under the description, such as a link to what can still be done.
 */
export function EmptyState({ title, description, children }: { title?: string; description?: string; children?: React.ReactNode }): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={`${styles.panel} ${styles.empty}`}>
      <span className={styles.emptyIcon} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-6l-2 3h-4l-2-3H2" />
          <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
        </svg>
      </span>
      <h2 className={styles.emptyTitle}>{title ?? t("states.empty.defaultTitle")}</h2>
      <p className={styles.description}>{description ?? t("states.empty.defaultDescription")}</p>
      {children}
    </div>
  );
}
